module.exports = __webpack_public_path__ + "img/Flur_01.e4a07886.png";